/* eslint-disable eqeqeq */
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
// common_groupstructure_GETROW
import Grid from "@mui/material/Grid";
import WmsHead from "./processComponent/WmsHead";
import WmsContent from "./processComponent/WmsContent";
import "./WMSStockReport.css";
import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";
// fExecuteAPI
import { fExecuteAPI } from "../../Server/Apis.jsx";

import {
  ReportTitle,
  ReportRemoveSequenceChar,
  ReportUrl,
} from "../../Utility/Utilitys";

import {
  sBufferObjInit,
  HeadObjectInit,
  sWebStockReportData,
  sWebStockReportArr,
  sExpiryData,
  sDueData,
  fWmsStockRepotArr,
  fWmsStockRepotBrandArr,
  GetWmsStockRepotBrand,
  GetLocation,
  GetBinAttribute,
  GetItemsAnalysis,
  GetWmsStockRepotMainSupplier,
  GetItemFullSearchArr,
  GetSearchItem,
  fValidationHead_Client,
  fValidationDetail_Client,
  sWMSStockReportCheckboxInit,
  NearExpirData,
  ExpiredItemData,
  BinwiseStockOverDueData,
  BinwiseStockPaidData,
  BinwiseStockDueDetailData,
  ItemswiseData,
} from "./WMSStockReportAction";
import {
  fAlertToast,
  Get_ToggleDropDown_binsearch_Load,
} from "../../Utility/Utilitys";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky.jsx";
// import { set } from 'date-fns/esm';

export default function WMSStockReport() {
  const vMediaQuery = useMediaQuery("(max-width:450px)");

  const [sDetailGridData, setDetailGridData] = useState([]);
  const [GridDataColumnsWmsSiDetail, setGridDataColumnsWmsSiDetail] = useState([
    {
      field: "id",
      headerName: "ID",
      width: 70,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "BinCd",
      headerName: "BinCd",
      width: 100,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "BinName",
      headerName: "BinName",
      width: 150,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "ItmCd",
      headerName: "ItmCd",
      width: 150,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "ItmName",
      headerName: "ItmName",
      width: 350,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "CARDID",
      headerName: "CARDID",
      width: 150,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "BaseQty",
      headerName: "BaseQty",
      width: 100,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "BatchNo",
      headerName: "BatchNo",
      width: 150,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "BatchDt",
      headerName: "BatchDt",
      width: 150,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "ExpDt",
      headerName: "ExpDt",
      width: 150,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "CoName1",
      headerName: "CoName1",
      width: 350,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "PostDt",
      headerName: "PostDt",
      width: 100,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "CostPr",
      headerName: "CostPr",
      width: 100,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "PTyp1",
      headerName: "PTyp1",
      width: 100,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "StockValue",
      headerName: "StockValue",
      width: 100,
      headerAlign: "right",
      align: "right",
    },
  ]); //DetailGridData Select

  //Head
  const [HeadObject, setHeadObject] = useState(HeadObjectInit);
  const [sPreviewGreadTitle, setPreviewGreadTitle] = useState("Binwise Detail");
  const [sBufferObj, setBufferObj] = useState({
    //BinRadiobtn
    sDetailReportRadioBtnName: "BINWISE_DETAIL",
    ItemwiseDropdown: ItemswiseData[0].Uid,
    BinwiseStockDueDetailDropdown: BinwiseStockDueDetailData[0].Uid,
    BinwiseStockPaidDropdown: BinwiseStockPaidData[0].Uid,
    BinwiseStockOverDueDropdown: BinwiseStockOverDueData[0].Uid,
    ExpiredItemDropdown: ExpiredItemData[0].Uid,
    ExpiredItemDate: new Date(),
    NearExpiryDropdown: NearExpirData[0].Uid,
    NearExpiryDate: new Date(),
  });

  const [sDetailViewTypeObj, setDetailViewTypeObj] = useState({
    //BinRadiobtn
    sDetailViewReportRadioBtnName: "Grid",
  });

  const [sLocationData, setLocationData] = useState([
    // { Uid: "Distribution", Value: "Distribution" },
  ]);

  const [sMainGroupData, setMainGroupData] = useState([
    // {
    //   Cd: "01",
    //   Name1: "FMCG FOOD",
    // },
  ]);

  const [sSubGroupData, setSubGroupData] = useState([
    // {
    //   Cd: "01",
    //   Name1: "FMCG FOOD",
    // },
  ]);

  const [sCategoryData, setCategoryData] = useState([
    // {
    //   Cd: "01",
    //   Name1: "FMCG FOOD",
    // },
  ]);

  const [sBrandData, setBrandData] = useState([]);
  const [sBrandCategoryData, setBrandCategoryData] = useState([]);

  const [sAisleData, setAisleData] = useState([
    // { Cd: "01", Name1: "01" },
    // { Cd: "02", Name1: "02" },
    // { Cd: "03", Name1: "03" },
    // { Cd: "04", Name1: "04" },
  ]);

  const [sLevelData, setLevelData] = useState([
    // { Cd: "L1", Name1: "L1" },
    // { Cd: "L2", Name1: "L2" },
    // { Cd: "L3", Name1: "L3" },
    // { Cd: "L4", Name1: "L4" },
  ]);

  const [sBinTypeData, setBinTypeData] = useState([
    // { Cd: "ACTIVE", Name1: "ACTIVE" },
    // { Cd: "DEFECTIVE ITEM", Name1: "DEFECTIVE ITEM" },
    // { Cd: "FLOOR BIN", Name1: "FLOOR BIN" },
    // { Cd: "IN-ACTIVE", Name1: "IN-ACTIVE" },
    // { Cd: "LOADING BIN", Name1: "LOADING BIN" },
    // { Cd: "OPEN BIN", Name1: "OPEN BIN" },
    // { Cd: "PROD-FINISHED GOODS", Name1: "PROD-FINISHED GOODS" },
    // { Cd: "PROD-RAW-MATERIAL", Name1: "PROD-RAW-MATERIAL" },
  ]);

  const [sMainSupplierData, setMainSupplierData] = useState([]);

  const [sProperty1Data, setProperty1Data] = useState([]);
  const [sProperty2Data, setProperty2Data] = useState([]);
  const [sProperty3Data, setProperty3Data] = useState([]);
  const [sProperty4Data, setProperty4Data] = useState([]);
  const [sAnalysis1Data, setAnalysis1Data] = useState([]);
  const [sAnalysis2Data, setAnalysis2Data] = useState([]);
  const [sAnalysis3Data, setAnalysis3Data] = useState([]);
  const [sAnalysis4Data, setAnalysis4Data] = useState([]);
  const [sAnalysis5Data, setAnalysis5Data] = useState([]);
  const [sAnalysis6Data, setAnalysis6Data] = useState([]);
  const [sAnalysis7Data, setAnalysis7Data] = useState([]);
  //checkbox Start
  const [sStockReportCheckBoxModal, setStockReportCheckBoxModal] =
    useState(false);

  const fOpenStockReportCheckBoxModal = () => {
    setStockReportCheckBoxModal(true);
  };

  const fCloseStockReportCheckBoxModal = (e) => {
    setStockReportCheckBoxModal(false);
  };

  const [sIsChecked, setIsChecked] = useState(false);
  const [WMSStockReportCheckbox, setWMSStockReportCheckbox] = useState({
    sProperty1Data: false,
    sProperty2Data: false,
    sProperty3Data: false,
    sProperty4Data: false,
    sAnalysis1Data: false,
    sAnalysis2Data: false,
    sAnalysis3Data: false,
    sAnalysis4Data: false,
    sAnalysis5Data: false,
    sAnalysis6Data: false,
    sAnalysis7Data: false,
  });
  const fSetCheckBox = (e) => {
    const nameValue = e.target.name;
    const iSCheck = e.target.checked;
    setWMSStockReportCheckbox((values) => ({
      ...values,
      [nameValue]: iSCheck,
    }));
  };

  const fIsAllChecked = (e) => {
    const iSCheck = e.target.checked;
    setIsChecked(iSCheck);
    setWMSStockReportCheckbox({
      sProperty1Data: iSCheck,
      sProperty2Data: iSCheck,
      sProperty3Data: iSCheck,
      sProperty4Data: iSCheck,
      sAnalysis1Data: iSCheck,
      sAnalysis2Data: iSCheck,
      sAnalysis3Data: iSCheck,
      sAnalysis4Data: iSCheck,
      sAnalysis5Data: iSCheck,
      sAnalysis6Data: iSCheck,
      sAnalysis7Data: iSCheck,
    });
  };

  useEffect(() => {
    const vIsAllTrue = Object.values(WMSStockReportCheckbox).every(
      (value) => value === true
    );
    setIsChecked(vIsAllTrue);
  }, [WMSStockReportCheckbox]);
  //checkbox End

  const DetailReportRadioBtn = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      sDetailReportRadioBtnName: e.target.value,
      ItemwiseDropdown: ItemswiseData[0].Uid,
      BinwiseStockDueDetailDropdown: BinwiseStockDueDetailData[0].Uid,
      BinwiseStockPaidDropdown: BinwiseStockPaidData[0].Uid,
      BinwiseStockOverDueDropdown: BinwiseStockOverDueData[0].Uid,
      ExpiredItemDropdown: ExpiredItemData[0].Uid,
      ExpiredItemDate: new Date(),
      NearExpiryDropdown: NearExpirData[0].Uid,
      NearExpiryDate: new Date(),
    }));
    setPreviewGreadTitle(e.target.name);
    if (e.target.value == "BIN_LEDGER" || e.target.value == "ITEM_LEDGER") {
      setDetailViewTypeObj((obj) => ({
        ...obj,
        sDetailViewReportRadioBtnName: "Report",
      }));
    } else {
      setDetailViewTypeObj((obj) => ({
        ...obj,
        sDetailViewReportRadioBtnName: "Grid",
      }));
    }
  };

  const DetailViewReportRadioBtn = (e) => {
    setDetailViewTypeObj((obj) => ({
      ...obj,
      sDetailViewReportRadioBtnName: e.target.value,
    }));
  };
  //Detail
  const fNearExpiryDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setBufferObj((obj) => ({
        ...obj,
        NearExpiryDate: "",
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        NearExpiryDate: e?.$d,
      }));
    }
  };
  const fNearExpiryDropdown = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      NearExpiryDropdown: e.target.value,
    }));
  };
  const fExpiredItemDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setBufferObj((obj) => ({
        ...obj,
        ExpiredItemDate: "",
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        ExpiredItemDate: e.$d,
      }));
    }
  };
  const fExpiredItemDropdown = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      ExpiredItemDropdown: e.target.value,
    }));
  };
  const fBinwiseStockOverDueDropdown = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      BinwiseStockOverDueDropdown: e.target.value,
    }));
  };
  const fBinwiseStockPaidDropdown = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      BinwiseStockPaidDropdown: e.target.value,
    }));
  };
  const fBinwiseStockDueDetailDropdown = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      BinwiseStockDueDetailDropdown: e.target.value,
    }));
  };
  const fItemwiseDropdown = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      ItemwiseDropdown: e.target.value,
    }));
  };

  //Head

  const fAisle = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAisle: e.target.value,
      sAislerArr: [],
      sAislerPrnt: "",
      sAislerName: "",
    }));
  };
  const fAisle_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAisleArr: value,
      sAislePrnt: value?.length <= 0 ? "" : currentPrnt,
      sAislerName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fLevel = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sLevel: e.target.value,
      sLevelArr: [],
      sLevelPrnt: "",
      sLevelName: "",
    }));
  };
  const fLevel_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");

    setHeadObject((obj) => ({
      ...obj,
      sLevelArr: value,
      sLevelPrnt: value?.length <= 0 ? "" : currentPrnt,
      sLevelName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fBinType = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sBinType: e.target.value,
      sBinTypeArr: [],
      sBinTypePrnt: "",
      sBinTypeName: "",
    }));
  };
  const fBinType_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");

    setHeadObject((obj) => ({
      ...obj,
      sBinTypeArr: value,
      sBinTypePrnt: value?.length <= 0 ? "" : currentPrnt,
      sBinTypeName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fLocation = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sLocation: e.target.value,
      sLocationArr: [],
      sLocationPrnt: "",
      sLocationName: "",
      sAisle: "All",
      sAisleCode: "",
      sAisleName: "",
      sBin: "All",
      sBinFromCode: "",
      sBinFromName: "",
    }));
  };

  const fLocation_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");

    setHeadObject((obj) => ({
      ...obj,
      sLocationArr: value,
      sLocationPrnt: value?.length <= 0 ? "" : currentPrnt,
      sLocationName: value?.length <= 0 ? "" : currentName,
    }));
    if (value?.length <= 0) {
      fLocation_Focus();
    }
  };
  const fLocation_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sAisle: "All",
      sAisleArr: "",
      sAislePrnt: "",
      sAisleName: "",
      sBin: "All",
      sBinFromCode: "",
      sBinFromName: "",
    }));
  };

  const fMainGroup = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sMainGroup: e.target.value,
      sMainGroupArr: [],
      sMainGroupPrnt: "",
      sMainGroupName: "",
      sSubGroup: "All",
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));
    setSubGroupData([]);
    setCategoryData([]);

    if (e.target.value.toUpperCase() == "ALL") {
      setMainGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj = {
        Prnt: "",
        Lvl: "1",
      };
      await fWmsStockRepotArr(xGroupStructureObj, setMainGroupData);
    }
  };

  const fMainGroup_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");

    setHeadObject((obj) => ({
      ...obj,
      sMainGroupArr: value,
      sMainGroupPrnt: value?.length <= 0 ? "" : currentPrnt,
      sMainGroupName: value?.length <= 0 ? "" : currentName,
    }));
    fMainGroup_Focus();
  };
  const fMainGroup_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sSubGroup: "All",
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));
    setSubGroupData([]);
    setCategoryData([]);
  };

  const fSubGroup = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));

    setCategoryData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setSubGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj2 = {
        Prnt: HeadObject.sMainGroupPrnt,
        Lvl: "2",
      };
      await fWmsStockRepotArr(xGroupStructureObj2, setSubGroupData);
    }
  };

  const fSubGroup_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sSubGroupArr: value,
      sSubGroupPrnt: value?.length <= 0 ? "" : currentPrnt,
      sSubGroupName: value?.length <= 0 ? "" : currentName,
    }));
    fSubGroup_Focus();
  };

  const fSubGroup_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));
    setCategoryData([]);
  };

  const fCategory = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));

    if (e.target.value.toUpperCase() == "ALL") {
      setCategoryData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj2 = {
        Prnt: HeadObject.sSubGroupPrnt,
        Lvl: "3",
      };

      await fWmsStockRepotArr(xGroupStructureObj2, setCategoryData);
    }
  };

  const fCategory_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sCategoryArr: value,
      sCategoryPrnt: value?.length <= 0 ? "" : currentPrnt,
      sCategoryName: value?.length <= 0 ? "" : currentName,
    }));
    fCategory_Focus();
  };
  const fCategory_Focus = (value) => {};

  const fBrand = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sBrandArr: [],
      sBrandPrnt: "",
      sBrandName: "",
      sBrandCategoryArr: [],
      sBrandCategoryPrnt: "",
      sBrandCategoryCode: "",
      sBrandCategoryName: "",
    }));
    setBrandCategoryData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setBrandData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotBrand(setBrandData);
    }
  };
  const fBrand_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sBrandArr: value,
      sBrandPrnt: value?.length <= 0 ? "" : currentPrnt,
      sBrandName: value?.length <= 0 ? "" : currentName,
    }));
    let xGroupStructureObj = {
      grp: value?.length <= 0 ? "" : currentPrnt,
    };
    await fWmsStockRepotBrandArr(xGroupStructureObj, setBrandCategoryData);
    fBrand_Focus();
  };

  const fBrand_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sBrandCategoryArr: [],
      sBrandCategoryPrnt: "",
      sBrandCategoryCode: "",
      sBrandCategoryName: "",
    }));
  };

  // const fBrandCategory = async (e) => {
  //   setHeadObject((obj) => ({
  //     ...obj,
  //     sBrandCategory: e.target.value,
  //     sBrandCategoryArr: [],
  //     sBrandCategoryPrnt: "",
  //     sBrandCategoryName: "",
  //   }));

  //   if (e.target.value.toUpperCase() == "ALL") {
  //     setBrandCategoryData([]);
  //   } else if (e.target.value.toUpperCase() == "IS") {
  //     let xGroupStructureObj2 = {
  //       grp: HeadObject.sBrandPrnt,
  //     };

  //     await fWmsStockRepotArr(xGroupStructureObj2, setBrandCategoryData);
  //   }
  // };

  const fBrandCategory_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sBrandCategoryArr: value,
      sBrandCategoryPrnt: value?.length <= 0 ? "" : currentPrnt,
      sBrandCategoryName: value?.length <= 0 ? "" : currentName,
    }));
  };

  //common_VendorListReport_GETROW
  const fMainSupplier = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sMainSupplierArr: [],
      sMainSupplierPrnt: "",
      sMainSupplierName: "",
    }));
    if (e.target.value.toUpperCase() == "ALL") {
      setMainSupplierData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotMainSupplier(setMainSupplierData);
    }
  };
  const fMainSupplier_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sMainSupplierArr: value,
      sMainSupplierPrnt: value?.length <= 0 ? "" : currentPrnt,
      sMainSupplierName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fProperty1 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sProperty1: e.target.value,
      sProperty1Arr: [],
      sProperty1Prnt: "",
      sProperty1Name: "",
    }));
  };
  const fProperty1_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sProperty1Arr: value,
      sProperty1Prnt: value?.length <= 0 ? "" : currentPrnt,
      sProperty1Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fProperty2 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sProperty2: e.target.value,
      sProperty2Arr: [],
      sProperty2Prnt: "",
      sProperty2Name: "",
    }));
  };
  const fProperty2_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sProperty2Arr: value,
      sProperty2Prnt: value?.length <= 0 ? "" : currentPrnt,
      sProperty2Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fProperty3 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sProperty3: e.target.value,
      sProperty3Arr: [],
      sProperty3Prnt: "",
      sProperty3Name: "",
    }));
  };
  const fProperty3_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sProperty3Arr: value,
      sProperty3Prnt: value?.length <= 0 ? "" : currentPrnt,
      sProperty3Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fProperty4 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sProperty4: e.target.value,
      sProperty4Arr: [],
      sProperty4Prnt: "",
      sProperty4Name: "",
    }));
  };
  const fProperty4_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sProperty4Arr: value,
      sProperty4Prnt: value?.length <= 0 ? "" : currentPrnt,
      sProperty4Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fAnalysis1 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis1: e.target.value,
      sAnalysis1Arr: [],
      sAnalysis1Prnt: "",
      sAnalysis1Name: "",
    }));
  };
  const fAnalysis1_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis1Arr: value,
      sAnalysis1Prnt: value?.length <= 0 ? "" : currentPrnt,
      sAnalysis1Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fAnalysis2 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis2: e.target.value,
      sAnalysis2Arr: [],
      sAnalysis2Prnt: "",
      sAnalysis2Name: "",
    }));
  };
  const fAnalysis2_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis2Arr: value,
      sAnalysis2Prnt: value?.length <= 0 ? "" : currentPrnt,
      sAnalysis2Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fAnalysis3 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis3: e.target.value,
      sAnalysis3Arr: [],
      sAnalysis3Prnt: "",
      sAnalysis3Name: "",
    }));
  };
  const fAnalysis3_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis3Arr: value,
      sAnalysis3Prnt: value?.length <= 0 ? "" : currentPrnt,
      sAnalysis3Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fAnalysis4 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis4: e.target.value,
      sAnalysis4Arr: [],
      sAnalysis4Prnt: "",
      sAnalysis4Name: "",
    }));
  };
  const fAnalysis4_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis4Arr: value,
      sAnalysis4Prnt: value?.length <= 0 ? "" : currentPrnt,
      sAnalysis4Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fAnalysis5 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis5: e.target.value,
      sAnalysis5Arr: [],
      sAnalysis5Prnt: "",
      sAnalysis5Name: "",
    }));
  };
  const fAnalysis5_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis5Arr: value,
      sAnalysis5Prnt: value?.length <= 0 ? "" : currentPrnt,
      sAnalysis5Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fAnalysis6 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis6: e.target.value,
      sAnalysis6Arr: [],
      sAnalysis6Prnt: "",
      sAnalysis6Name: "",
    }));
  };
  const fAnalysis6_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis6Arr: value,
      sAnalysis6Prnt: value?.length <= 0 ? "" : currentPrnt,
      sAnalysis6Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fAnalysis7 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis7: e.target.value,
      sAnalysis7Arr: [],
      sAnalysis7Prnt: "",
      sAnalysis7Name: "",
    }));
  };
  const fAnalysis7_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis7Arr: value,
      sAnalysis7Prnt: value?.length <= 0 ? "" : currentPrnt,
      sAnalysis7Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fCancel = (e) => {
    setHeadObject(HeadObjectInit);
    setBufferObj(sBufferObjInit);
    setDetailViewTypeObj({
      sDetailViewReportRadioBtnName: "Grid",
    });
    setMainGroupData([]);
    setSubGroupData([]);
    setCategoryData([]);
    setBrandData([]);
    setBrandCategoryData([]);
    setMainSupplierData([]);
    setWMSStockReportCheckbox(sWMSStockReportCheckboxInit);
    setPreviewGreadTitle("Binwise Detail");
  };

  const fBin = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sBin: e.target.value,
      sBinFromCode: "",
      sBinFromName: "",
    }));
  };

  const fBinFromName = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sBinFromName: e.target.value,
    }));
  };

  const fBinFromName_onKeyUp = async (e) => {
    // fBinNameKey(e);
    if (e.key === "Enter" || e._reactName === "onClick") {
      const vExactSearch = await Get_ToggleDropDown_binsearch_Load(
        HeadObject.sBinFromName,
        "Any",
        "Y",
        ""
      );

      if (vExactSearch.length > 0) {
        setHeadObject((obj) => ({
          ...obj,
          sBinFromCode: vExactSearch[0].UId,
          sBinFromName: vExactSearch[0].Name1,
        }));
      } else {
        fAlertToast("FAILED", "Wrong bin name");
      }
    }
    if (e.key === "Backspace") {
      setHeadObject((obj) => ({
        ...obj,
        sBinFromCode: "",
      }));
    }
    // if (e.key == "ArrowDown" || e.keyCode == 40) {
    //   setTimeout(() => {
    //     var selectedLength =
    //       document.getElementsByClassName("Mui-selected").length;
    //     if (selectedLength === 0) {
    //       let tabel = document.getElementById(
    //         "table-main-grid-dropdown-Toggle"
    //       );
    //       tabel
    //         ?.getElementsByClassName("MuiDataGrid-row")[0]
    //         ?.firstChild?.focus();
    //     }
    //   }, 100);
    // }
  };

  const fCardId = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sCardIdFrom: "",
    }));
  };

  const fCardIdFrom = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sCardIdFrom: e.target.value,
    }));
  };

  const fCardIdFrom_onKeyUp = async (e) => {
    // fBinNameKey(e);
    if (e.key === "Enter" || e._reactName === "onClick") {
      if (HeadObject.sCardIdFrom === "") {
        fAlertToast("FAILED", "CardID is empty");
      } else {
        GetCartIDDetail(HeadObject.sCardIdFrom);
      }
    }
    if (e.key === "Backspace") {
      setHeadObject((obj) => ({
        ...obj,
        sCardIdFrom: "",
      }));
    }
    // if (e.key == "ArrowDown" || e.keyCode == 40) {
    //   setTimeout(() => {
    //     var selectedLength =
    //       document.getElementsByClassName("Mui-selected").length;
    //     if (selectedLength === 0) {
    //       let tabel = document.getElementById(
    //         "table-main-grid-dropdown-Toggle"
    //       );
    //       tabel
    //         ?.getElementsByClassName("MuiDataGrid-row")[0]
    //         ?.firstChild?.focus();
    //     }
    //   }, 100);
    // }
  };

  const GetCartIDDetail = async (xCardId) => {
    const CartBarcodeDetailObj = {
      CardId: xCardId,
    };
    const CartBarcodeDetail = await fExecuteAPI(
      "NOTIFICATION_PICKINGCARDIDSEARCH_GETROW",
      CartBarcodeDetailObj
    );
    if (CartBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (CartBarcodeDetail.ResultSet.length > 0) {
        setHeadObject((obj) => ({
          ...obj,
          sCardIdForm: CartBarcodeDetail.ResultSet[0].CardID,
        }));
      } else {
        fAlertToast("WARNING", "Wrong card Id");
      }
    } else {
      fAlertToast("FAILED", CartBarcodeDetail.response.data.message);
    }
  };

  //Item start
  const GridDataColumnsItemSearch = [
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "ItmCd", headerName: "ItmCd", width: 90 },
    { field: "Name1", headerName: "Name1", width: 450 },
    { field: "NameFL", headerName: "NameFL", width: 90 },
    { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
    { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
    { field: "Model", headerName: "Model", width: 90 },
    { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
    { field: "BarCode", headerName: "BarCode", width: 90 },
  ];

  const ItemSearchData = ["Any", "Code", "Barcode", "Name", "RefNo", "NameFL"];
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const fItem = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sItem: e.target.value,
      sItemName: "",
      sItemCode: "",
    }));
  };
  const fItemName = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sItemName: e.target.value,
    }));
  };

  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(HeadObject.sItemName);

      if (vItemSearchFull.length > 0) {
        setHeadObject((obj) => ({
          ...obj,
          sItemCode: vItemSearchFull[0].ItmCd,
          sItemName: vItemSearchFull[0].Name2,
        }));
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setHeadObject((obj) => ({
        ...obj,
        sItemCode: "",
        sItemName: e.target.value,
      }));
    }
  };

  //GCItemSearch
  const fGCToggleItemOnRowClick = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sItemCode: e.row.ItmCd,
      sItemName: e.row.Name1,
    }));
    let vItemSearchFull = await GetItemFullSearchArr(e.row.ItmCd);
    if (vItemSearchFull.length > 0) {
      setHeadObject((obj) => ({
        ...obj,
        sItemCode: vItemSearchFull[0].ItmCd,
        sItemName: vItemSearchFull[0].Name2,
      }));
      // document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      // document.getElementsByName("B_ItmName")[0]?.focus();
    }
    setItemToggleDropdown(false);
  };

  //GCItemSearch
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      // setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);
      // setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      setTimeout(() => {
        document?.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  }, [sItemToggleDropdown]);

  const fItemToggleClick = (e) => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: HeadObject.sItemName,
    }));

    if (HeadObject.sItemName != "") {
      GetSearchItem(HeadObject.sItemName, "Any", setGridSelectRowData);
    }

    handleClick();
  };

  //Item End

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const GetReportsView = async () => {
    let xType = sBufferObj.sDetailReportRadioBtnName;
    let xParam01 = "";

    let urlPrint = vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val;
    let sCurrentReport = "";
    let sReportTitle = "";
    if (sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "ITEMSWISE") {
      xType = sBufferObj.ItemwiseDropdown;
    } else if (
      sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "NR_EXP"
    ) {
      xParam01 = moment(sBufferObj.NearExpiryDate).format("MM-DD-YYYY");
      xType = sBufferObj.NearExpiryDropdown;
    } else if (
      sBufferObj.sDetailReportRadioBtnName?.toUpperCase() == "EXP_ITEM"
    ) {
      xParam01 = moment(sBufferObj.ExpiredItemDate).format("MM-DD-YYYY");
      xType = sBufferObj.ExpiredItemDropdown;
    } else if (
      sBufferObj.sDetailReportRadioBtnName?.toUpperCase() == "STK_BIN_OD"
    ) {
      xType = sBufferObj.BinwiseStockOverDueDropdown;
    } else if (
      sBufferObj.sDetailReportRadioBtnName?.toUpperCase() == "STK_PAID"
    ) {
      xType = sBufferObj.BinwiseStockPaidDropdown;
    } else if (
      sBufferObj.sDetailReportRadioBtnName?.toUpperCase() == "STK_DUE"
    ) {
      xType = sBufferObj.BinwiseStockDueDetailDropdown;
    }
    //  http://192.168.50.243:8010/CF1WebRpt/(S(pw3qa1tmwc2kvc4hf05fkh0a))/WMS/StockReport?trntyp=ITM_CONS&loc=64&mainGrp=All&subGrp=All&grp=All
    const supplierName = HeadObject?.sMainSupplierArr
      .map((x) => x.Name1)
      .join(", ");
    const brandName = HeadObject?.sBrandArr.map((x) => x.Name1).join(", ");

    let ReportTitleObj = {
      Location: HeadObject.sLocationName,
      MainGroup: HeadObject.sMainGroupName,
      SubGroup: HeadObject.sSubGroupName,
      Group: HeadObject.sCategoryName,
      MainSupplier: supplierName,
      Brand: brandName,
      ItemName: HeadObject.sItemName,
      CardID: !!HeadObject.sCardIdFrom ? HeadObject.sCardIdFrom : "0",
      Aisle: HeadObject.sAisleName,
      Level: HeadObject.sLevelName,
      BinType: HeadObject.sBinTypeName,
      // BinCode: HeadObject.sBinFromCode,
      BinName: HeadObject.sBinFromName,
      Analysis1: HeadObject.sAnalysis1Name,
      Analysis2: HeadObject.sAnalysis2Name,
      Analysis3: HeadObject.sAnalysis3Name,
      Analysis4: HeadObject.sAnalysis4Name,
      Analysis5: HeadObject.sAnalysis5Name,
      Analysis6: HeadObject.sAnalysis6Name,
      Analysis7: HeadObject.sAnalysis7Name,
      Property1: HeadObject.sProperty1Name,
      Property2: HeadObject.sProperty2Name,
      Property3: HeadObject.sProperty3Name,
      Property4: HeadObject.sProperty4Name,
    };

    sReportTitle = ReportTitle(ReportTitleObj);
    const suplGrpData = HeadObject?.sMainSupplierArr
      .map((x) => x.AcCd)
      .join(",");
    const brandGrpData = HeadObject?.sBrandArr.map((x) => x.UID).join(",");

    let ReportUrlObj = {
      trntyp: xType,
      loc: HeadObject.sLocationPrnt,
      mainGrp: HeadObject.sMainGroupPrnt,
      subGrp: HeadObject.sSubGroupPrnt,
      grp: HeadObject.sCategoryPrnt,
      supplier: suplGrpData,
      brand: brandGrpData,
      itmCd: HeadObject.sItemCode,
      cardID1: !!HeadObject.sCardIdFrom ? HeadObject.sCardIdFrom : "0",
      aisle: HeadObject.sAislePrnt,
      level: HeadObject.sLevelPrnt,
      binTyp: HeadObject.sBinTypePrnt,
      binCd1: HeadObject.sBinFromCode,
      pParam01: xParam01, //as of now by sir
      analysis1: HeadObject.sAnalysis1Prnt,
      analysis2: HeadObject.sAnalysis2Prnt,
      Analysis3: HeadObject.sAnalysis3Prnt,
      analysis4: HeadObject.sAnalysis4Prnt,
      analysis5: HeadObject.sAnalysis5Prnt,
      analysis6: HeadObject.sAnalysis6Prnt,
      analysis7: HeadObject.sAnalysis7Prnt,
      property1: HeadObject.sProperty1Prnt,
      property2: HeadObject.sProperty2Prnt,
      property3: HeadObject.sProperty3Prnt,
      property4: HeadObject.sProperty4Prnt,
      reportTitle: sReportTitle,
    };

    sCurrentReport = ReportUrl(ReportUrlObj);

    sCurrentReport = ReportRemoveSequenceChar(sCurrentReport);

    console.log(
      "sCurrentReport",
      urlPrint + "WMS/StockReport?" + sCurrentReport
    );
    setWebReportUrlModal(urlPrint + "WMS/StockReport?" + sCurrentReport);

    fWebReport();
    // const CurrentReportBinwiseStockArr = await Reports_BinwiseStock_GETROW(
    //   BinwiseStockObj
    // );
    // if (CurrentReportBinwiseStockArr?.status === 200) {
    //   let CurrentReportBinwiseStockGridRowData =
    //     CurrentReportBinwiseStockArr?.data?.ResultSet?.map((obj, i) => ({
    //       ...obj,
    //       id: i + 1,
    //     }));

    //   setDetailGridData(CurrentReportBinwiseStockGridRowData);
    //   fView();
    // }
  };

  console.log("HeadObject.sBrandCategoryName", HeadObject.sBrandCategoryName);

  const fPreview = async (e) => {
    let iValidationHead_Client = fValidationHead_Client(HeadObject);
    if (!iValidationHead_Client) return;

    let iValidationDetail_Client = fValidationDetail_Client(
      sBufferObj,
      HeadObject
    );
    if (!iValidationDetail_Client) return;

    await GetReportsView();

    // if (sDetailViewTypeObj.sDetailViewReportRadioBtnName == "Grid") {
    //   let xGitterDataColumnID =
    //     "STK_RPT_" + sBufferObj.sDetailReportRadioBtnName;

    //   if (sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "ITEMSWISE") {
    //     xGitterDataColumnID = "STK_RPT_" + sBufferObj.ItemwiseDropdown;
    //   } else if (
    //     sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "NR_EXP"
    //   ) {
    //     xGitterDataColumnID = "STK_RPT_" + sBufferObj.NearExpiryDropdown;
    //   } else if (
    //     sBufferObj.sDetailReportRadioBtnName?.toUpperCase() == "EXP_ITEM"
    //   ) {
    //     xGitterDataColumnID = "STK_RPT_" + sBufferObj.ExpiredItemDropdown;
    //   } else if (
    //     sBufferObj.sDetailReportRadioBtnName?.toUpperCase() == "STK_BIN_OD"
    //   ) {
    //     xGitterDataColumnID =
    //       "STK_RPT_" + sBufferObj.BinwiseStockOverDueDropdown;
    //   } else if (
    //     sBufferObj.sDetailReportRadioBtnName?.toUpperCase() == "STK_PAID"
    //   ) {
    //     xGitterDataColumnID = "STK_RPT_" + sBufferObj.BinwiseStockPaidDropdown;
    //   } else if (
    //     sBufferObj.sDetailReportRadioBtnName?.toUpperCase() == "STK_DUE"
    //   ) {
    //     xGitterDataColumnID =
    //       "STK_RPT_" + sBufferObj.BinwiseStockDueDetailDropdown;
    //   }
    //   await GetGitterColumns(
    //     setGridDataColumnsWmsSiDetail,
    //     xGitterDataColumnID,
    //     GridDataColumnsWmsSiDetail
    //   );

    //   await GetReportsView();
    // } else {
    //   fWebReport();
    // }
  };

  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  useEffect(() => {
    const handleClick = (event) => {
      if (sItemToggleDropdown) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setItemToggleDropdown(false);
          // setGC_Toggle_Head_BinName_ToggleDropDowm(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sItemToggleDropdown]);

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //Modal fWebReportModal
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  const fLoad = async () => {
    await GetLocation(setLocationData);
    await GetBinAttribute(setAisleData, setLevelData, setBinTypeData);
    await GetItemsAnalysis(
      setProperty1Data,
      setProperty2Data,
      setProperty3Data,
      setProperty4Data,
      setAnalysis1Data,
      setAnalysis2Data,
      setAnalysis3Data,
      setAnalysis4Data,
      setAnalysis5Data,
      setAnalysis6Data,
      setAnalysis7Data
    );
  };

  useEffect(() => {
    fLoad();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div></div>
        <div className="col-12">
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={vMediaQuery ? "py-4" : "py-4"}
          >
            <Grid item xs={12} sm={12} md={8}>
              <WmsHead
                fLocation_MultiSelect={fLocation_MultiSelect}
                sLocationData={sLocationData}
                fMainGroup_MultiSelect={fMainGroup_MultiSelect}
                sMainGroupData={sMainGroupData}
                fSubGroup_MultiSelect={fSubGroup_MultiSelect}
                sSubGroupData={sSubGroupData}
                fCategory_MultiSelect={fCategory_MultiSelect}
                sCategoryData={sCategoryData}
                fBrand_MultiSelect={fBrand_MultiSelect}
                sBrandData={sBrandData}
                fBrandCategory_MultiSelect={fBrandCategory_MultiSelect}
                sBrandCategoryData={sBrandCategoryData}
                fMainSupplier_MultiSelect={fMainSupplier_MultiSelect}
                sMainSupplierData={sMainSupplierData}
                fBinFromName_onKeyUp={fBinFromName_onKeyUp}
                fBinFromName={fBinFromName}
                fCardIdFrom_onKeyUp={fCardIdFrom_onKeyUp}
                fCardIdFrom={fCardIdFrom}
                fAisle_MultiSelect={fAisle_MultiSelect}
                fLevel_MultiSelect={fLevel_MultiSelect}
                fBinType_MultiSelect={fBinType_MultiSelect}
                fProperty1={fProperty1}
                fProperty1_MultiSelect={fProperty1_MultiSelect}
                fProperty2={fProperty2}
                fProperty2_MultiSelect={fProperty2_MultiSelect}
                fProperty3={fProperty3}
                fProperty3_MultiSelect={fProperty3_MultiSelect}
                fProperty4={fProperty4}
                fProperty4_MultiSelect={fProperty4_MultiSelect}
                fAnalysis1={fAnalysis1}
                fAnalysis1_MultiSelect={fAnalysis1_MultiSelect}
                fAnalysis2={fAnalysis2}
                fAnalysis2_MultiSelect={fAnalysis2_MultiSelect}
                fAnalysis3={fAnalysis3}
                fAnalysis3_MultiSelect={fAnalysis3_MultiSelect}
                fAnalysis4={fAnalysis4}
                fAnalysis4_MultiSelect={fAnalysis4_MultiSelect}
                fAnalysis5={fAnalysis5}
                fAnalysis5_MultiSelect={fAnalysis5_MultiSelect}
                fAnalysis6={fAnalysis6}
                fAnalysis6_MultiSelect={fAnalysis6_MultiSelect}
                fAnalysis7={fAnalysis7}
                fAnalysis7_MultiSelect={fAnalysis7_MultiSelect}
                //multiselect
                sProperty1Data={sProperty1Data}
                sProperty2Data={sProperty2Data}
                sProperty3Data={sProperty3Data}
                sProperty4Data={sProperty4Data}
                sAnalysis1Data={sAnalysis1Data}
                sAnalysis2Data={sAnalysis2Data}
                sAnalysis3Data={sAnalysis3Data}
                sAnalysis4Data={sAnalysis4Data}
                sAnalysis5Data={sAnalysis5Data}
                sAnalysis6Data={sAnalysis6Data}
                sAnalysis7Data={sAnalysis7Data}
                sWebStockReportData={sWebStockReportData}
                sWebStockReportArr={sWebStockReportArr}
                sAisleData={sAisleData}
                sLevelData={sLevelData}
                sBinTypeData={sBinTypeData}
                HeadObject={HeadObject}
                setHeadObject={setHeadObject}
                fLocation={fLocation}
                fMainGroup={fMainGroup}
                fSubGroup={fSubGroup}
                fCategory={fCategory}
                fMainSupplier={fMainSupplier}
                fBrand={fBrand}
                // fBrandCategory={fBrandCategory}

                fCardId={fCardId}
                fAisle={fAisle}
                fLevel={fLevel}
                fBinType={fBinType}
                fBin={fBin}
                fItem={fItem}
                fItemName_onKeyUp={fItemSearchKey}
                fItemName={fItemName} //onchange main input
                xMediaQuery={vMediaQuery} //mobile screen
                xonClickbtn={fItemSearchKey} // onclick icon open div on main screen
                xrows={sGridSelectRowData} //Grid Row GCToggle Search from API
                xcolumns={GridDataColumnsItemSearch} //GCToggleSearch-Grid col GCToggle Search fron Action
                xRowCellClick={fGCToggleItemOnCellKeyDown} //GCToggleSearch-grid clic
                xRowClick={fGCToggleItemOnRowClick} //GCToggleSearch- grid click
                xToggle={sItemToggleDropdown} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
                xData={ItemSearchData} // GCToggleSearch-select-tag arr
                xOnChangeDropdownInput={fOnChangeItem} //GCToggleSearch-input search onchane DATA/TYPE
                xDropdownObj={sItemSearchDropdownObj} // GCToggleSearch-object DATA/TYPE
                xOnKeyUpDropdownInput={fOnKeyUpItem} //GCToggleSearch
                //Checkbox start
                sStockReportCheckBoxModal={sStockReportCheckBoxModal}
                fOpenStockReportCheckBoxModal={fOpenStockReportCheckBoxModal}
                fCloseStockReportCheckBoxModal={fCloseStockReportCheckBoxModal}
                sIsChecked={sIsChecked}
                WMSStockReportCheckbox={WMSStockReportCheckbox}
                fSetCheckBox={fSetCheckBox}
                fIsAllChecked={fIsAllChecked}
                //Checkbox end
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              className={vMediaQuery ? "hide-content" : " "}
            >
              <WmsContent
                xtitle={"Detail Report"}
                selectedOption={sBufferObj.sDetailReportRadioBtnName}
                DetailReportRadioBtn={DetailReportRadioBtn}
                sDueData={sDueData}
                sExpiryData={sExpiryData}
                sBufferObj={sBufferObj}
                fNearExpiryDate={fNearExpiryDate}
                fNearExpiryDropdown={fNearExpiryDropdown}
                fExpiredItemDate={fExpiredItemDate}
                fExpiredItemDropdown={fExpiredItemDropdown}
                fBinwiseStockOverDueDropdown={fBinwiseStockOverDueDropdown}
                fBinwiseStockPaidDropdown={fBinwiseStockPaidDropdown}
                fBinwiseStockDueDetailDropdown={fBinwiseStockDueDetailDropdown}
                fItemwiseDropdown={fItemwiseDropdown}
                DetailViewReportRadioBtn={DetailViewReportRadioBtn}
                selectedOptionView={
                  sDetailViewTypeObj.sDetailViewReportRadioBtnName
                }
              />
            </Grid>
          </Grid>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 0, md: 0 }}
            columnSpacing={{ xs: 1, sm: 0, md: 3 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              vMediaQuery
                ? " justify-content-center text-center"
                : "py-2 justify-content-center text-center"
            }
          >
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Preview"
                xOnClick={fPreview}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Cancel"
                xOnClick={fCancel}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>

            <Grid
              item
              xs={6}
              sm={6}
              md={"auto"}
              className={
                vMediaQuery ? "text-center" : "text-center hide-content"
              }
            >
              <CmpButton
                xbtnName="Detail"
                xOnClick={fSummary}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
          </Grid>
        </div>
      </div>

      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Detail Report"} onClose={fCloseSummaryModal} />

          <div className="py-3 px-2">
            <WmsContent
              xtitle=""
              selectedOption={sBufferObj.sDetailReportRadioBtnName}
              DetailReportRadioBtn={DetailReportRadioBtn}
              sDueData={sDueData}
              sExpiryData={sExpiryData}
              sBufferObj={sBufferObj}
              fNearExpiryDate={fNearExpiryDate}
              fNearExpiryDropdown={fNearExpiryDropdown}
              fExpiredItemDate={fExpiredItemDate}
              fExpiredItemDropdown={fExpiredItemDropdown}
              fBinwiseStockOverDueDropdown={fBinwiseStockOverDueDropdown}
              fBinwiseStockPaidDropdown={fBinwiseStockPaidDropdown}
              fBinwiseStockDueDetailDropdown={fBinwiseStockDueDetailDropdown}
              fItemwiseDropdown={fItemwiseDropdown}
              DetailViewReportRadioBtn={DetailViewReportRadioBtn}
              selectedOptionView={
                sDetailViewTypeObj.sDetailViewReportRadioBtnName
              }
            />
          </div>
        </Box>
      </Modal>

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </div>
  );
}
